module.exports = __webpack_public_path__ + "static/img/download.6cc9c960.svg";